export default {
    SET_LOADING_STATE: "jobTemplate/SET_LOADING_STATE",
    SET_JOB_TEMPLATE_DATA: "jobTemplate/SET_JOB_TEMPLATE_DATA",
    SET_JOB_TYPE_LIST: "jobTemplate/SET_JOB_TYPE_LIST",
    SET_DIALOG_STATE: "jobTemplate/SET_DIALOG_STATE",
    SET_JOB_TEMPLATE: "jobTemplate/SET_JOB_TEMPLATE",
    SET_EDIT_JOB_TEMPLATE_DATA: "jobTemplate/SET_EDIT_JOB_TEMPLATE_DATA",
    RESET_FORM_DATA: "jobTemplate/RESET_FORM_DATA"
}